import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition
} from "app/library/layout-builder";

import {CorporationProps} from "./types";
import {CorporationPropertyDefinitions} from 'components/cms/definitions';

export class CorporationDefinitions extends CmsReactComponent<CorporationProps> {

    static schemaName = "corporation";


    static propertyDefinitions: PropertyDefinition[] = CorporationPropertyDefinitions;


}
